<div class="welcome-page">
    <div class="welcome-page__top">
        <header class="welcome-page__top__header">
            <div class="welcome-page__language-selection">
                <app-button
                        [ariaLabel]="('SCREEN_READER.LANGUAGE.SELECT_GERMAN' | translate) + ('GENERAL.BUTTON' | translate)"
                        [cssClasses]="'btn switch-slim switch__gray-01'"
                        [hideLabelMobileOnly]="true"
                        [customIcon]="'german'"
                        [active]="activeLanguage === germanButtonEnum"
                        (buttonClicked)="changeLanguage(germanButtonEnum)">
                    Deutsch
                </app-button>
                <app-button
                        [ariaLabel]="('SCREEN_READER.LANGUAGE.SELECT_ENGLISH' | translate) + ('GENERAL.BUTTON' | translate)"
                        [cssClasses]="'btn switch-slim switch__gray-01'"
                        [hideLabelMobileOnly]="true"
                        [customIcon]="'english'"
                        [active]="activeLanguage === englishButtonEnum"
                        (buttonClicked)="changeLanguage(englishButtonEnum)">
                    English
                </app-button>
                <app-button
                        [ariaLabel]="('SCREEN_READER.LANGUAGE.SELECT_SERBIAN' | translate) + ('GENERAL.BUTTON' | translate)"
                        [cssClasses]="'btn switch-slim switch__gray-01'"
                        [hideLabelMobileOnly]="true"
                        [customIcon]="'serbian'"
                        [active]="activeLanguage === serbianButtonEnum"
                        (buttonClicked)="changeLanguage(serbianButtonEnum)">
                    Srpski
                </app-button>
            </div>
            <div class="audio-indication" *ngIf="autoTextRead">
                <mat-icon class="material-icons-round audio-indication__icon">volume_upp</mat-icon>
                <p class="audio-indication__text">{{'GENERAL.AUDIO_MODE' | translate}}: <span>ON</span></p>
            </div>
            <div class="header-controls">
                <div class="header-tts-buttons">
                    <div class="header-controls__play">
                        <app-button
                                [ariaLabel]="((ttsIconState === playState ? 'SCREEN_READER.HEADER.PLAY_BUTTON' : 'SCREEN_READER.HEADER.PAUSE_BUTTON') | translate) + ('GENERAL.BUTTON' | translate)"
                                [cssClasses]="'solid__blue-08 circle wh-80'"
                                [iconState]="ttsIconState"
                                (buttonClicked)="readText()">
                        </app-button>
                    </div>
                    <div class="header-controls__repeat">
                        <app-button
                                [ariaLabel]="('SCREEN_READER.HEADER.REPEAT_BUTTON' | translate) + ('GENERAL.BUTTON' | translate)"
                                [cssClasses]="'solid__blue-02 circle wh-60'"
                                [icon]="'replay'"
                                [iconColor]="'blue-10'"
                                [disabled]="repeatButtonDisabled"
                                (buttonClicked)="play()">
                        </app-button>
                    </div>
                </div>
            </div>
        </header>
        <div role="main" class="welcome-page__top__intro">
            <div class="welcome-page__top__intro__image">
                <img src="assets/images/bayer_application_image_on_tablet.png"
                     alt="image of Bayer consent application on tablet view">
            </div>
            <div class="welcome-page__top__intro__text">
                <p class="welcome-page__top__intro__welcome">{{'GENERAL.WELCOME_TO' | translate}}</p>
                <h1 class="welcome-page__top__intro__project"
                    [innerHTML]="'PROJECT.WELCOME_TITLE' | translate">
                </h1>
                <p class="welcome-page__top__intro__title-info">{{'PROJECT.WELCOME_TITLE_INFO' | translate}}</p>
                <p class="welcome-page__top__intro__description">
                    {{ 'PROJECT.DESCRIPTION' | translate }}
                    <app-button id="bayerFocus"
                            [ariaLabel]="'Bayer link popup' + ('GENERAL.BUTTON' | translate)"
                            [cssClasses]="'popup-link only-text only-text__small'"
                            (buttonClicked)="openBayerPopUpDialog()">
                        {{'GENERAL.BAYER' | translate}}
                    </app-button>
                    {{'GENERAL.AND' | translate}}
                    <app-button id="healthbankFocus"
                            [ariaLabel]="'Healthbank link popup' + ('GENERAL.BUTTON' | translate)"
                            [cssClasses]="'popup-link only-text only-text__small'"
                            (buttonClicked)="openHealthBankPopUpDialog()">
                        {{'GENERAL.HEALTHBANK' | translate}}
                    </app-button>
                </p>
                <app-login
                        [isAudioMode]="autoTextRead"
                        (stopAudioEvent)="pause(false)">
                </app-login>
            </div>
        </div>
    </div>
    <div class="welcome-page__bottom"></div>
</div>
